import auth_en from './auth/en'
import nav_en from './nav/en'
import dashboard_en from './dashboard/en'
import user_en from './user/en'
import item_en from './item/en'
import set_en from './set/en'
import tag_en from './tag/en'
import plan_en from './plan/en'
import common_en from './common/en'
import exhibition_en from './exhibition/en'
import manual_en from './manual/en'

export default {
  auth: auth_en,
  nav: nav_en,
  dashboard: dashboard_en,
  user: user_en,
  item: item_en,
  set: set_en,
  tag: tag_en,
  plan: plan_en,
  common: common_en,
  exhibition: exhibition_en,
  manual: manual_en
}
